import { createFileRoute } from '@tanstack/react-router'
import { RunDetail } from '@/features/runs/detail'

function RunDetailRoute() {
  const { runId } = Route.useParams()
  return <RunDetail runId={runId} />
}

export const Route = createFileRoute('/runs/$runId')({
  component: RunDetailRoute,
})
